export default "/images/d257361e7a68c937133e8185785ff939.avif";